import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight, Users, Clock, BarChart } from 'lucide-react';

import { coursesData } from '../../data/courses.ts'; // Adjust path as needed

const courses = coursesData.slice(0, 3);; // Use the imported data

const CourseShowcase = () => {
  return (
    <section className="bg-gray-50 section-padding">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="heading-lg mb-6">Nos formations phares</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Découvrez nos programmes de formation en IA les plus populaires, conçus pour répondre
            aux besoins spécifiques des entreprises dans différents secteurs.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {courses.map((course, index) => (
            <motion.div
              key={course.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="card group flex flex-col h-full"
            >
              <div className="relative overflow-hidden">
                <img
                  src={course.image}
                  alt={course.title}
                  width="400"
                  height="192"
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 bg-white py-1 px-3 rounded-full text-xs font-medium text-primary">
                  {course.category}
                </div>
              </div>

              <div className="p-6 flex-grow flex flex-col">
                <h3 className="text-xl font-semibold mb-3">{course.title}</h3>
                <p className="text-gray-600 mb-6">{course.description}</p>

                <div className="flex flex-wrap gap-4 mb-6 mt-auto">
                  <div className="flex items-center text-sm text-gray-500">
                    <BarChart className="h-4 w-4 mr-1" />
                    <span>{course.level}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <Clock className="h-4 w-4 mr-1" />
                    <span>{course.duration}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-500">
                    <Users className="h-4 w-4 mr-1" />
                    <span>10-15 participants</span>
                  </div>
                </div>

                <Link to={`/formationIA/${course.slug}/`} className="group inline-flex items-center text-primary font-medium hover:text-primary-light transition-colors">
                  Voir les détails
                  <ChevronRight className="ml-1 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/formation-ia-entreprise/" className="btn-primary">
            Voir toutes nos formations
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CourseShowcase;